import { CoreIcon } from '../core-icon';
import timeFillSVG from '../../assets/icons/time-fill.svg';
import type { IconProps } from '../core-icon';

export const TimeFillIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={timeFillSVG} {...props} />;
};
